module.exports = __webpack_public_path__ + "static/img/left.ac740c90.jpg";